import firebase from '@/firebase/firebase'

const ref = firebase.firestore()
var batch = ref.batch()

/**
 * Propagate changes to all related products
 */
export function propagate (companyId, optionId, option) {

    return new Promise( async (resolve) => {
        try {
            let affectedProductsRef = ref.collection(`/company/${companyId}/productInOption`)
            let affectedProducts = await affectedProductsRef.where('options', 'array-contains', optionId).get()

            for (let i = 0; i < affectedProducts.docs.length; i++) {
                const prodRef = ref.collection(`/company/${companyId}/products/`).doc(affectedProducts.docs[i].id)
                const prod = await prodRef.get()

                if(prod.exists) {
                    let prodData = prod.data()
                    const newObjOpt = {}
                    newObjOpt[optionId] = option
                    const newOptions = Object.assign(prodData.options, newObjOpt)

                    prod.options = newOptions
                    batch.update(prodRef, prodData)
                }
            }
            
            await batch.commit()
            batch = ref.batch()
    
            resolve('')
        } catch (err) {
            resolve(err.message)
        }
    })
}